var __jsx = React.createElement;
import { LinearProgress } from '@material-ui/core';
import compact from 'lodash/compact';
import React, { useMemo } from 'react';
import { InstantSearch } from 'react-instantsearch-core';
import { ContentStatus, getLinkableContentTypesBySite } from '@uno/common-cms';
import { Configure } from 'components/content/Algolia';
import { useSiteConfig } from 'libs/common/hooks';
import { useAlgoliaSearchClient } from 'libs/content/hooks';
import AutocompleteInput from './AutocompleteInput';

var LinkedContentInput = function LinkedContentInput(_ref) {
  var _ref$contentTypeNames = _ref.contentTypeNames,
      contentTypeNames = _ref$contentTypeNames === void 0 ? [] : _ref$contentTypeNames,
      publishedContentOnly = _ref.publishedContentOnly,
      name = _ref.name,
      label = _ref.label,
      defaultValue = _ref.defaultValue;

  var _useAlgoliaSearchClie = useAlgoliaSearchClient(),
      searchClient = _useAlgoliaSearchClie.searchClient,
      sortingIndexNames = _useAlgoliaSearchClie.sortingIndexNames;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var facetFilters = useMemo(function () {
    var statusFilter = publishedContentOnly === true ? "status:".concat(ContentStatus.READY) : null;
    var linkableContentTypes = contentTypeNames.length > 0 ? contentTypeNames : getLinkableContentTypesBySite(site).map(function (contentType) {
      return contentType.name;
    });
    var contentTypeFilters = linkableContentTypes.map(function (contentTypeName) {
      return "contentType:".concat(contentTypeName);
    });
    return compact([contentTypeFilters, statusFilter]);
  }, [contentTypeNames, publishedContentOnly, site]);
  return __jsx(React.Fragment, null, !searchClient ? __jsx(LinearProgress, null) : __jsx(InstantSearch, {
    indexName: sortingIndexNames.modificationDate.desc,
    searchClient: searchClient
  }, __jsx(Configure, {
    facetFilters: facetFilters
  }), __jsx(AutocompleteInput, {
    name: name,
    label: label,
    defaultValue: defaultValue
  })));
};

export default LinkedContentInput;